<template>
    <Page>
        <Container class="max-w-screen-sm">
            <Title>Search Users</Title>

            <div class="mb-6">
                <TextInput
                    v-model="searchQuery"
                    placeholder="Search by email, name, or username..."
                    @input="handleSearch"
                />
            </div>

            <Loading v-if="loading" />

            <div v-if="!loading && users.length === 0 && searchQuery" class="text-center py-8 text-gray-500">
                No users found
            </div>

            <div v-if="!loading && users.length > 0" class="space-y-4">
                <div
                    v-for="user in users"
                    :key="user.id"
                    class="bg-neutral-100 dark:bg-neutral-800 rounded p-4"
                >
                    <div class="flex items-center justify-between">
                        <div>
                            <div class="font-semibold">{{ `${user.first_name} ${user.last_name}` }}</div>
                            <div class="text-sm text-gray-600 dark:text-gray-400">{{ user.email }}</div>
                            <div v-if="user.username" class="text-sm text-gray-600 dark:text-gray-400">
                                @{{ user.username }}
                            </div>
                            <div class="text-sm text-gray-500 dark:text-gray-500 mt-1">
                                {{ user.workout_count || 0 }} {{ user.workout_count === 1 ? 'workout' : 'workouts' }}
                            </div>
                            <div v-if="user.last_activity_at" class="text-sm text-gray-500 dark:text-gray-500 mt-1">
                                Last active: {{ formatDate(user.last_activity_at) }}
                            </div>
                        </div>
                        <div class="text-right text-sm">
                            <div v-if="user.subscribed" class="text-green-600 dark:text-green-400">Subscribed</div>
                            <div v-else-if="user.on_trial" class="text-yellow-600 dark:text-yellow-400">Trial</div>
                            <div v-else class="text-gray-500">Free</div>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    </Page>
</template>

<script>
import {defineComponent} from 'vue'
import {mapActions} from 'vuex';
import _ from 'lodash';
import moment from 'moment-timezone';

export default defineComponent({
  name: 'UserSearch',
  data() {
    return {
      loading: false,
      searchQuery: '',
      users: [],
      searchDebounced: null,
    };
  },
  created() {
    this.searchDebounced = _.debounce(this.performSearch, 300);
  },
  methods: {
    ...mapActions({
      adminSearchUsers: 'admin/searchUsers',
    }),
    formatDate(dateString) {
      if (!dateString) return '';
      return moment(dateString).fromNow();
    },
    handleSearch() {
      if (this.searchQuery.trim().length === 0) {
        this.users = [];
        return;
      }
      this.searchDebounced();
    },
    performSearch() {
      if (this.searchQuery.trim().length === 0) {
        this.users = [];
        return;
      }

      console.log('UserSearch.performSearch - searchQuery:', this.searchQuery);
      
      this.loading = true;
      return this.adminSearchUsers({
        q: this.searchQuery,        
      }).then((response) => {
        console.log('UserSearch.performSearch - response:', response);
        const rawUsers = response.data.data || [];
        // Extract attributes from JsonApiSerializer format
        this.users = rawUsers.map(user => {
          if (user.attributes) {
            return {
              id: user.id,
              ...user.attributes,
            };
          }
          return user;
        });
      }).catch(() => {
        this.users = [];
      }).finally(() => {
        this.loading = false;
      });
    },
  },
})
</script>

<style scoped lang="scss">

</style>
